import { object, string } from "yup";

export const schema = object({
  email: string()
    .required("Please enter your email")
    .email("Please enter a valid email address"),
});
